import { ActionTree, Commit, MutationTree } from 'vuex';
import { State } from '@/store/modules/global/settings/settings.store';
import { Duration, DurationTime, Context, Params } from '@/utils/types/global';
import axios, { AxiosResponse } from 'axios';
import { CommonService } from '@/services/api/common.service';
import graphQl from '@/services/graphQl';
import axiosInstance from '@/services/api/http.service';
import getEnv from '@/utils/env';
import { ROLES } from './settings.config';
import { UploadFile } from 'ant-design-vue';

const API_URL =
  getEnv('VUE_APP_AUTH_HOST') ||
  process.env.VUE_APP_AUTH_HOST ||
  'https://localhost:4000';
import { CustomDBService } from '@/services/api/custom-db.service';
import { STATUS_LABEL } from '@/components/Log/log.constants';
import fragmentAll from '@/store/modules/global/settings/customDB.metric.types';
const OAP_HOST = getEnv('VUE_APP_OAP_HOST') || 'http://localhost:12800';

const actions: ActionTree<State, any> = {
  setUtc(context: { commit: Commit }, data: number): void {
    context.commit('setUtc', data);
    context.commit('runEvents');
  },
  setDuration(context: { commit: Commit }, data: Duration): void {
    context.commit('setDuration', data);
    // if (window.axiosCancel.length !== 0) {
    //   for (const event of window.axiosCancel) {
    //     setTimeout(event(), 0);
    //   }
    //   window.axiosCancel = [];
    // }
    context.commit('runEvents');
  },
  setLicenseDuration(context: { commit: Commit }, data: Duration): void {
    context.commit('setLicenseDuration', data);
    // if (window.axiosCancel.length !== 0) {
    //   for (const event of window.axiosCancel) {
    //     setTimeout(event(), 0);
    //   }
    //   window.axiosCancel = [];
    // }
    context.commit('runEvents');
  },
  resetDuration(context: { commit: Commit }): void {
    context.commit('resetDuration');
    context.commit('runEvents');
  },
  runEvents(context: { commit: Commit }): void {
    // if (window.axiosCancel.length !== 0) {
    //   for (const event of window.axiosCancel) {
    //     setTimeout(event(), 0);
    //   }
    //   window.axiosCancel = [];
    // }
    context.commit('runEvents');
  },
  setCharts(context: { commit: Commit }, data: any[]): void {
    context.commit('setCharts', data);
  },
  clearCharts(context: { commit: Commit }): void {
    context.commit('setCharts', []);
  },
  getAllTimeZones(context: { commit: Commit }, data: any): void {
    try {
      CommonService.getAllTimeZone()
        .then((resp) => {
          context.commit('setTimezones', resp.data);
        })
        .catch((error) => error);
    } catch (error) {
      console.log('Error occured', error);
    }
  },
  setCurrTimeLabel(context: { commit: Commit }, data: String): void {
    context.commit('setCurrTimeLabel', data);
  },
  getTransactionApplicationsAction(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }

    return graphQl
      .query('getTransactionApplications')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data?.data?.resp || {};
        } else return {};
      });
  },
  getTransactionEndpointsAction(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }

    return graphQl
      .query('getTransactionEndpoints')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data?.data?.resp || {};
        } else return {};
      });
  },
  updateOrDeleteTransApplication(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }

    return graphQl
      .query('mutateTransApplicationRule')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data?.data?.resp || {};
        } else return {};
      });
  },
  updateOrDeleteTransEndpoint(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }

    return graphQl
      .query('mutateTransEndpointRule')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data?.data?.resp || {};
        } else return {};
      });
  },
  checkAIenable(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }

    return graphQl
      .query('checkAIenabled')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data.data) {
          return res.data.data.checkAIEnablement || {};
        } else return {};
      });
  },
  getInstancesAction(context: { commit: Commit }, params: any): any {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }

    return graphQl
      .query('queryGetInstances')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.response;
        } else return {};
      });
  },
  enableOrDeleteCodeProfileAction(
    context: { commit: Commit },
    params: any
  ): any {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }

    return graphQl
      .query('enableOrDeleteCodeProfileInstance')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.response;
        } else return [];
      });
  },
  deleteCodeProfileAction(context: { commit: Commit }, params: any): any {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }

    return graphQl
      .query('deleteCodeProfileInstance')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.response;
        } else return [];
      });
  },
  getCodeProfileInstances(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }

    return graphQl
      .query('queryGetCodeProfileInstances')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.response;
        } else return [];
      });
  },
  async getUsers(context: { commit: Commit }) {
    const response = await new axiosInstance({
      auth: true,
    }).get(`${API_URL}/users/list`);

    const { userList } = response.data;

    const filteredUsers = userList?.filter((user) =>
      Object.keys(ROLES).includes(user.roleName),
    );

    context.commit('setUsers', filteredUsers);

    return filteredUsers;
  },
  async addUser(
    context: { commit: Commit },
    params: {
      email: String;
      role: String;
      firstName: String;
      lastName: String;
    },
  ) {
    const response = await new axiosInstance({
      auth: true,
    }).post(`${API_URL}/teams/member/onboard`, params);

    return response.data;
  },
  async editUser(
    context: { commit: Commit },
    params: {
      userId: String;
      role: String;
      firstName: String;
      lastName: String;
    },
  ) {
    const { userId, ...restBody } = params;
    const response = await new axiosInstance({
      auth: true,
    }).put(`${API_URL}/users/${userId}`, restBody);

    return response.data;
  },
  async deleteUser(
    context: { commit: Commit },
    params: {
      userId: String;
    },
  ) {
    const { userId } = params;
    const response = await new axiosInstance({
      auth: true,
    }).delete(`${API_URL}/users/${userId}`);

    return response.data;
  },
  async resetLink(
    context: { commit: Commit },
    params: {
      userId: String;
    },
  ) {
    const { userId } = params;
    const response = await new axiosInstance({
      auth: true,
    }).post(
      `${API_URL}/users/password/request_reset/${userId}?sendBackLink=true`,
    );

    return response.data;
  },
  async queryValidation(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('mutateQueryValidation')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data?.data?.resp || {};
        } else return {};
      });
  },
  async queryValidationStatus(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('mutateQueryValidationStatus')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data?.data?.dbmCustomQueryStatus  || {};
        } else return {};
      });
  },

  async saveQuery(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('mutateSaveQueryInfo')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data?.resp || {};
        } else return {};
      });
  },
  async displayQueryTableInfo(context: { commit: Commit }, params: any) {
    const defaultValue = {
      total: 0,
      records: []
    }
    return graphQl
      .query('displayQueryInfo')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data?.data?.queryValues) {
          const data ={
            total: res.data?.data?.queryValues?.total,
            records: res.data?.data?.queryValues?.queryValues,
          };
          return data || defaultValue;
          } else
          return defaultValue;
        });  
  },
  async displayRunQueryInfo(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('runQueryInfo')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data?.data?.runQuery || [];
        } else return [];
      });
    },
    getCustomDBGraphData(context: Context, params: Params) {
      const config =
        context.rootState.globalState.app.chartsTemplate.application[
          params.layoutIndex
        ][params.index];
  
      return CustomDBService.getGraphData({
        service_id: params.serviceId,
        duration: params.duration,
        metric_name: config.metricName
      }).then(res => {
        const resData = res.data.data;
        const graphData = {
          [config['queryMetricType']]: {
            values: {
              values: resData.values
            }
          }
        };
        return new Array({
          ...graphData,
          config
        });
      });
    },
    getCustomDBDashboardWidgetData(context: Context, params: any) {
      let config = params.chartConfig || params.config;
      let variable;
      if (
        config.queryMetricType === 'readMetricsValues' ||
        config.queryMetricType === 'readMetricsValue'
      ) {
        variable = {
          duration: params.duration,
          condition: {
            name: 'meter_custom_db_queries',
            entity: {
              scope: 'ServiceInstance',
              serviceName: config.serviceKey,
              serviceInstanceName: config.serviceKey+ '_' + btoa(config.widgetName.slice(0,-3)),
              normal: true
            },
            isLatestValue: config.isLatestValue,
            sort: config.sort
          },
        };
      }
      const fragments =
        config.chartType === STATUS_LABEL
          ? fragmentAll[config.queryMetricType].fragmentAvgValue
          : fragmentAll[config.queryMetricType].fragment;
      const queryVariables = fragmentAll[config.queryMetricType].variable;
      const query = `query queryData(${queryVariables}) {${fragments}}`;
      return new axiosInstance({ auth: true })
        .post(
          OAP_HOST + '/graphql',
          { query, variables: variable },
          {
            // cancelToken: cancelToken()
          }
        )
        .then((res: AxiosResponse<any>) => {
          const resData = res.data.data;
          return [
            {
              ...resData,
              config,
              metricName: variable.condition.name
            }
          ];
        });
    },
  async uploadLicense(context: { commit: Commit }, file: UploadFile<any>) {
    const formData = new FormData();

    formData.append('file', file.originFileObj || (file as unknown as Blob));

    const response = await new axiosInstance({
      auth: true,
    }).post(`${API_URL}/license/upload-license`, formData);

    return response.data;
  },
};

export default actions;
